import { render, staticRenderFns } from "./Service-Form-Detail.vue?vue&type=template&id=e8c1044e"
import script from "./Service-Form-Detail.vue?vue&type=script&lang=js"
export * from "./Service-Form-Detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports